"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// https://formkit.com/essentials/examples
var isCheckboxAndRadioMultiple = function (node) {
    return (node.props.type === "checkbox" || node.props.type === "radio") &&
        node.props.options;
};
function addAsteriskPlugin(node) {
    node.on("created", function () {
        if (!node.props.definition || !node.context || node.type !== "input") {
            return;
        }
        var inputTypeUniqueKey = node.props.definition.schemaMemoKey || node.context.type;
        node.props.definition.schemaMemoKey = "required_".concat(isCheckboxAndRadioMultiple(node) ? 'multi_' : "").concat(inputTypeUniqueKey);
        node.context.isRequired = node.props.parsedRules.some(function (rule) { return rule.name === "required"; });
        node.on('prop:validation', function () {
            if (!node.context)
                return;
            node.context.isRequired = node.props.parsedRules.some(function (rule) { return rule.name === 'required'; });
        });
        // it would be better to have a proper type check here, but this plugin comes straight
        // from the FormKit site, so we'll just assert this and assume they know what they're doing
        var schemaFn = node.props.definition
            .schema;
        node.props.definition.schema = function (sectionsSchema) {
            if (sectionsSchema === void 0) { sectionsSchema = {}; }
            sectionsSchema[isCheckboxAndRadioMultiple(node) ? 'legend' : 'label'] = {
                children: ['$label', {
                        $el: 'span',
                        if: '$isRequired',
                        attrs: {
                            class: '$classes.asterisk',
                        },
                        children: ['*']
                    }]
            };
            return schemaFn(sectionsSchema);
        };
    });
}
exports.default = addAsteriskPlugin;
